const FieldType = Object.freeze({
    CHECKBOX: 'checkbox',
    DOB: 'dateofbirth',
    RADIO: 'radiobutton',
    SELECT: 'select',
    TEXTAREA: 'textarea',
    TEXTBOX: 'textbox',
});

module.exports = FieldType;
